import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import VerifiedIcon from "@mui/icons-material/Verified";
import SmsRoundedIcon from "@mui/icons-material/SmsRounded";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import GoogleIcon from "@mui/icons-material/Google";
import WebhookIcon from "@mui/icons-material/Webhook";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import { Business } from "@mui/icons-material";
import CopyAllOutlinedIcon from "@mui/icons-material/CopyAllOutlined";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CampaignIcon from "@mui/icons-material/Campaign";
import HideSourceIcon from "@mui/icons-material/HideSource";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import CachedIcon from '@mui/icons-material/Cached';
export const baseIconStyle = {
  fontSize: 24,
};

export const iconConfig = {
  click: {
    component: AdsClickIcon,
    style: { color: "#8033F4" },
  },

  refresh: {
    component: CachedIcon,
    style: { color: "#8033F4" },
  },

  plus: {
    component: AddIcon,
    style: { color: "#8033F4" },
  },

  whatsapp_web: {
    component: WhatsAppIcon,
    style: { color: "#8033F4" },
  },

  whatsapp_api: {
    component: VerifiedIcon,
    style: { color: "#8033F4" },
  },

  email: {
    component: EmailRoundedIcon,
    style: { color: "#8033F4" },
  },

  hide: {
    component: HideSourceIcon,
    style: { color: "#8033F4" },
  },

  sms: {
    component: SmsRoundedIcon,
    style: { color: "#8033F4" },
  },

  delete: {
    component: DeleteIcon,
    style: { color: "#8033F4" },
  },

  settings: {
    component: SettingsIcon,
    style: { color: "#8033F4" },
  },

  "Google planilhas": {
    component: GoogleIcon,
    style: { color: "#8033F4" },
  },

  // 🔥 fallback visual
  file: {
    component: WysiwygIcon,
    style: { color: "#8033F4" },
  },

  API: {
    component: WebhookIcon,
    style: { color: "#8033F4" },
  },

  Excel: {
    component: NewspaperIcon,
    style: { color: "#8033F4" },
  },

  ERP: {
    component: Business,
    style: { color: "#8033F4" },
  },

  duplicate: {
    component: CopyAllOutlinedIcon,
    style: { color: "#8033F4" },
  },
  edit: {
    component: ModeEditIcon,
    style: { color: "#8033F4" },
  },
  "view-off": {
    component: VisibilityOffIcon,
    style: { color: "#8033F4" },
  },

  view: {
    component: VisibilityIcon,
    style: { color: "#8033F4" },
  },

  campaign: {
    component: CampaignIcon,
    style: { color: "#8033F4" },
  },
};
